module.exports = __webpack_public_path__ + "img/ic_notebook.773776cf.svg";